import React, { Component } from 'react';

import { SelectItemProps } from 'ui/form/fields';
import styles from './select.scss';

interface SelectItemState {}


export default class SelectItem extends Component<SelectItemProps, SelectItemState> {
  // For Checking if item is of type SelectItem
  static select(): boolean { return true; }
  
  handleSelect = e => {
    const { icon, value, disabled, onSelect } = this.props;
    if (!disabled && onSelect) {
      onSelect(e, value, icon);
    }
  };
  
  
  render() {
    const { focus, icon, label, disabled, selected } = this.props;

    let cl = [styles.item];
    if (disabled) cl.push(styles.disabled);
    if (focus) cl.push(styles.focus);
    if (selected) cl.push(styles.selected);

    return (
      <div className={cl.join(' ')} onClick={this.handleSelect}>
        {icon && <div className={styles.icon}>{icon}</div>}
        <div className={styles.label}>
          <div>{this.label}</div>
          {label && <small className={styles.textFade}>{label}</small>}
        </div>
      </div>
    );
  }
}
